module.exports = "/_next/static/images/Brian Lovin-b185ba2372913831cfe3d61669b16e09.jpg";